// extracted by mini-css-extract-plugin
export default {"titleDateRow":"ExperienceBubble_titleDateRow__Wtg5L"};